import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Ul, Li } from '@atoms';
import { PageTemplate } from '@templates';
import { Panel } from '@layout';
import { BlockedAttendee } from './BlockedAttendee';
import messages from './messages';

export class BlockedAttendeesPage extends PureComponent {
  static propTypes = {
    blockedAttendees: PropTypes.arrayOf(PropTypes.object).isRequired,
    getBlockedAttendees: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.getBlockedAttendees();
  }

  render() {
    return (
      <PageTemplate title={<FormattedMessage {...messages.header} />}>
        <Panel>
          <Ul>
            {this.props.blockedAttendees.map((attendee) => (
              <Li key={attendee.id}>
                <BlockedAttendee
                  attendee={attendee}
                  unblockAttendee={this.props.unblockAttendee}
                />
              </Li>
            ))}
          </Ul>
        </Panel>
      </PageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/BlockedAttendeesPage/BlockedAttendeesPage.js